/**
 * 国家选择列表
 */
import React, { Component } from 'react';

import Countries from './countries';
import CountryCodes from './countryCode';
import lang from '../../lang';
import NumberUtil from '../../lib/util/number';

class CountryView extends Component {
	
    static defaultProps = {
        visible: false,
		selectOption: function(){}
	}

	constructor(props){
		super(props);

		// 系统语言
		let _lang = UP.Global.systemLanguage;
        // let countryCode = _lang.split('-')[1].toUpperCase();
        
        // let whiteList = ['CN', 'JP', 'VN']; // 默认国家码白名单

        // if (whiteList.indexOf(countryCode) == -1) {
        // 	countryCode = '';
        // }
        let user = UP.Global.getUser() || {};
        let countryCode = user.countryCode || '';

        this.state = Object.assign(
            {
                countries: Countries,
                visible: props.visible
            }, 
            this.getInputValueByCode(countryCode)
        );
	}

    componentWillMount() {
        this.props.selectOption(this.state);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible
        });
    }

	getInputValueByCode(code) {
		let name = '';
		let num = '';

        if (CountryCodes[code]) {
	        $.each(Countries, function(key, value) {
	            if (key ==  code) {
	                name = lang.template(key);
	                return false;
	            }
	        });
	        
	        num =  NumberUtil.prefixed(CountryCodes[code], 4);
        }
        
        return {
            code: code,
            areaCode: num,
            inputValuePlusCode: name ? '+' + CountryCodes[code]  : '',
            inputValue: name
        }
    }

	filter(val) {
        let list = this.state.countries;
        let result = {};
        
        $.each(Countries, function(key, value) {
            let name = lang.template(key);
            let num = CountryCodes[key];

            if (val.match(/^[0-9]+$/)) {
                if (num && num.indexOf(val) > -1) {
                    result[key] = value;
                }
            } else {
                if (name.indexOf(val) > -1) {
                    result[key] = value;
                }
            }
        });

        return result;
    }

	onChange=(e)=>{
        let el = $(e.currentTarget);
        let val = el.val();
        
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            let countries = this.filter(val);
            this.setState({
                countries: countries
            });
        }, 300);
    }

	onClickOption(code) {
     	let state = Object.assign( { }, this.getInputValueByCode(code) );

        this.props.selectOption(state);
        this.setState(state);
    }

	render() {
        let $options = [];

		$.map(this.state.countries, (value, key) =>{
            if (CountryCodes[key]) {
                
                let cls = this.state.code == key ? 'selected' : '';

                let node = (
                    <li className={cls} key={key} data-code={key} onClick={()=>this.onClickOption(key)}>
                        <label>{lang.template(key)}</label>
                        <em>(+{CountryCodes[key]})</em>
                    </li>
                )

                $options[$options.length] = node;
            }
        });

        return (
            <div className="country-list-wrap" style={{ display: this.state.visible ? 'block': 'none'}}>
                <div className="search-bar">
                    <div className="input-wrapper" ><input className="input" onKeyUp={this.onChange} placeholder={lang.template('搜索')}/></div>
                </div>
                <ul className="country-list">
                    {$options}
                </ul>
            </div>
        );
	}
}

export default CountryView;


// WEBPACK FOOTER //
// ./js/component/select-country/country-view.js